import { render, staticRenderFns } from "./LoadPortal.vue?vue&type=template&id=0931af5e&scoped=true"
import script from "./LoadPortal.vue?vue&type=script&lang=js"
export * from "./LoadPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0931af5e",
  null
  
)

export default component.exports